import { render, staticRenderFns } from "./PatchnoteContent.vue?vue&type=template&id=e0bda042&scoped=true"
import script from "./PatchnoteContent.vue?vue&type=script&lang=js"
export * from "./PatchnoteContent.vue?vue&type=script&lang=js"
import style0 from "./PatchnoteContent.vue?vue&type=style&index=0&id=e0bda042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bda042",
  null
  
)

export default component.exports